export const alert = function (message, type = 'info') {
	return {
		message,
		type: type,
		timestamp: new Date().getTime(),
		seen: false,
	};
};
